<motif-modal-title class="confirm-header">
  <!-- <motif-icon size="30" *ngIf="data.icon" [iconFunction]="data.icon"></motif-icon>
  <h2 [innerHTML]="data.name | translate"></h2>
  <button motifIconButton aria-label="Close modal" [motif-modal-close]="true" [size]="buttonSizes.LARGE">
    <motif-icon class="motif-modal-header-close-icon" [iconFunction]="closeIcon"></motif-icon>
  </button> -->
  <div class="confirmheader-container">
    <motif-icon size="30" class="motif-icon" *ngIf="data.icon" [iconFunction]="data.icon"></motif-icon>
    <!-- Archive/unarchive titles intentionally contain <b> markup; Angular sanitizes innerHTML by default. -->
    <!-- Static {{ }} fallback child keeps the heading non-empty for accessibility/static-analysis tooling; [innerHTML] still fully controls the rendered markup at runtime. -->
    @let plainTitle = stripHtml(data.name | translate);
    <h2 class="header-title" [innerHTML]="data.name | translate" [attr.aria-label]="plainTitle">{{ plainTitle }}</h2>
  </div>
  <button motifIconButton aria-label="Close modal" [motif-modal-close]="false" [size]="buttonSizes.LARGE"
    class="close-button">
    <motif-icon class="motif-modal-header-close-icon" [iconFunction]="closeIcon"></motif-icon>
  </button>

  <!-- <div class="modal-header">
    <div class="left-content">
      <motif-icon size="30" *ngIf="data.icon" [iconFunction]="data.icon"></motif-icon>
      <h2 [innerHTML]="data.name | translate"></h2>
    </div>
    <button motifIconButton aria-label="Close modal" [motif-modal-close]="true" [size]="buttonSizes.LARGE">
      <motif-icon class="motif-modal-header-close-icon" [iconFunction]="closeIcon"></motif-icon>
    </button>
  </div> -->
</motif-modal-title>
<motif-modal-content>
  <div class="description" [innerHTML]="data.description | translate"></div>

</motif-modal-content>
<hr class="exp-line" />
<motif-modal-actions class="dialog-footer">
  <button motifButton color="secondary" [motif-modal-close]="true" aria-label="ok">
    {{data.okButtonText | translate}}
  </button>
  <button motifButton color="primary" [motif-modal-close]="false" aria-label="cancel">
    {{data.cancelButtonText|translate}}
  </button>
</motif-modal-actions>